(function() { window.GUID_25126398_66f7_4eea_a3da_fa5e80e1199c = { getGuid: function() { return "25126398-66f7-4eea-a3da-fa5e80e1199c"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        var VideoPlayerInternals;
        (function (VideoPlayerInternals) {
            /** This class is only to manage the show/hide of the ui on touch */
            class TouchedVideo extends VideoPlayerInternals.BaseInternal {
                get isControlsVisible() { return this._isControlsVisible; }
                constructor(player) {
                    super(player);
                    this.timeoutMs = 4500;
                    this._isControlsVisible = false;
                    this.suspendedState = {
                        showBigPlayVisible: false,
                        timerIsActive: false,
                        suspended: false
                    };
                    this.videoTouchend = (e) => {
                        this.ToogleControlsVisibility();
                        if (this.videoTouchendTimeout == null)
                            this.setTouchTimer();
                        else {
                            clearTimeout(this.videoTouchendTimeout);
                            this.videoTouchendTimeout = null;
                        }
                    };
                    this.controls = player.controls;
                    this.container = player.$Control;
                    this.video = player.video;
                }
                ToogleControlsVisibility() { this.ControlsVisibility(!this.isControlsVisible); }
                ControlsVisibility(visible) {
                    if (visible == this.isControlsVisible)
                        return;
                    var event = new ControlsVisibilityChangeEventArgs({
                        isVisible: visible,
                        size: { Height: this.controls.height(), Width: this.controls.width() }
                    });
                    this.eventRaiser.ControlsVisibilityChange(null, event);
                    if (!event.isPreventDefaultAction) {
                        if (visible)
                            this.container.addClass("show-big-play");
                        else
                            this.container.removeClass("show-big-play");
                        this.refreshControlsVisibility();
                        this._isControlsVisible = visible;
                        this.eventRaiser.ControlsVisibilityChanged(null, event);
                    }
                }
                get Suspended() { return this.suspendedState.suspended; }
                Suspend(controlsVisible) {
                    if (!this.Suspended) {
                        this.suspendedState = {
                            showBigPlayVisible: this.container.hasClass("show-big-play"),
                            timerIsActive: this.videoTouchendTimeout != null,
                            suspended: true
                        };
                        if (this.suspendedState.timerIsActive)
                            this.clearTouchTimer();
                        if (this.suspendedState.showBigPlayVisible)
                            this.container.removeClass("show-big-play");
                        if (controlsVisible != null)
                            if (controlsVisible == true)
                                this.controls.addClass("show");
                            else
                                this.controls.removeClass("show");
                    }
                    return () => {
                        this.suspendedState.suspended = false;
                        this.controls.removeClass("show");
                        if (this.suspendedState.timerIsActive)
                            this.setTouchTimer();
                        if (this.suspendedState.showBigPlayVisible)
                            this.container.addClass("show-big-play");
                        else
                            this.container.removeClass("show-big-play");
                    };
                }
                timerHandler() {
                    this.videoTouchendTimeout = null;
                    this.ControlsVisibility(false);
                }
                refreshControlsVisibility() {
                    if (this.container.hasClass("show-big-play") == false) {
                        this.controls.removeClass("show");
                        this.controls.addClass("dont-show");
                    }
                    else {
                        this.controls.addClass("show");
                        this.controls.removeClass("dont-show");
                    }
                }
                resetTouchTimer() {
                    if (this.videoTouchendTimeout != null)
                        this.setTouchTimer();
                }
                setTouchTimer() {
                    if (this.videoTouchendTimeout != null)
                        this.clearTouchTimer();
                    this.videoTouchendTimeout = window.setTimeout(() => { this.timerHandler(); }, this.timeoutMs);
                }
                clearTouchTimer() {
                    clearTimeout(this.videoTouchendTimeout);
                    this.videoTouchendTimeout = null;
                }
                OnBindEvents() {
                    this.event(this.container.find('.play-circle'))
                        .offon('touchend', (e, s) => {
                        this.resetTouchTimer();
                        this.player.PlayPause();
                        e.stopPropagation();
                        e.preventDefault();
                    })
                        .offon('click', (e, s) => {
                        this.player.PlayPause();
                        e.stopPropagation();
                        e.preventDefault();
                    });
                    this.event(this.container.find('.not-started'))
                        .offon('touchend', (e, s) => { this.videoTouchend(e); });
                    this.event(this.video).offon("touchend", this.videoTouchend);
                }
                OnDispose() {
                }
            }
            VideoPlayerInternals.TouchedVideo = TouchedVideo;
            class ControlsVisibilityChangeEventArgs {
                constructor(data) {
                    this._isPreventDefaultAction = false;
                    this.isVisible = data.isVisible;
                    this.size = data.size;
                }
                preventDefaultAction() {
                    this._isPreventDefaultAction = true;
                }
                get isPreventDefaultAction() {
                    return this._isPreventDefaultAction;
                }
            }
        })(VideoPlayerInternals = Controls.VideoPlayerInternals || (Controls.VideoPlayerInternals = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=VideoPlayer.TouchedVideo.pre.js.map
